import { useTranslations } from '@/i18n/use-translations';
import Modal from '@/components/common/modal';
import EventCatalogProduct from '@/components/events/event-catalog/event-catalog-product.tsx';
import { PRODUCT_KEYS } from '@/types/dtos/orders/response/product.dto.ts';

const AddMediaStorageModal = ({ open, onModalClose }: { open: boolean; onModalClose: () => void }) => {
  const t = useTranslations();

  return (
    <Modal
      open={open}
      handleClose={onModalClose}
      size="md"
      data-testid="add-media-storage-modal"
      title={t('media.addMediaStorageModalTitle')}
      description={t('media.addMediaStorageModalText')}
    >
      <EventCatalogProduct productKey={PRODUCT_KEYS.DATA_TRANSFER_GB} />
    </Modal>
  );
};

export default AddMediaStorageModal;
